import * as TOP_EQUITY_FUNDS from './topFundsData/fundequity.json';

import * as TOP_DEBT_FUNDS from './topFundsData/funddebt.json';

import * as TOP_ELSS_FUNDS from './topFundsData/fundelss.json';

import * as TOP_SMALL_MIDCAP_FUNDS from './topFundsData/fundsmallmidcap.json';

import * as TOP_BALANCED_FUNDS from './topFundsData/fundbalanced.json';

import * as TOP_AGGRESSIVE_SIPS from './topFundsData/fundaggressive.json';

import * as TOP_LIQUID_FUNDS from './topFundsData/fundliquid.json';

import * as TOP_SMALL_MIDCAP_SECTORIAL_FUNDS from './topFundsData/fundsmallmidcapsectorial.json';

import * as TOP_BALANCED_LARGECAP from './topFundsData/fundbalancedlargecap.json';

export default {
  TOP_EQUITY_FUNDS,
  TOP_DEBT_FUNDS,
  TOP_ELSS_FUNDS,
  TOP_SMALL_MIDCAP_FUNDS,
  TOP_BALANCED_FUNDS,
  TOP_LIQUID_FUNDS,
  TOP_BALANCED_LARGECAP,
  TOP_SMALL_MIDCAP_SECTORIAL_FUNDS,
  TOP_AGGRESSIVE_SIPS,
  TOP_FUNDS: [].concat(TOP_EQUITY_FUNDS, TOP_DEBT_FUNDS, TOP_ELSS_FUNDS),
};



// WEBPACK FOOTER //
// ./constants/fundBuckets/topFunds.ts